module.exports = __webpack_public_path__ + "h5/img/cs_16.85a331fb.jpeg";